module.exports = __webpack_public_path__ + "static/media/secretBanner_sm2.9ec3b1be.png";